import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import editIcon from '../../../images/icon-editing.svg';
import deleteIcon from '../../../images/icon-trash.svg';
import iconEye from '../../../images/icon-eye.svg';
import iconLoginAsUser from '../../../images/icon-line-manage-clients.svg';
import iconAssignProgram from '../../../images/assign-program.png';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { assignCoach, deleteClient } from '../../../redux/slices/admin/clientsSlice'; 
import { loginAsUser } from '../../../redux/slices/adminAuthSlice';
import { useNavigate } from 'react-router-dom';

const ClientsTable = ({ handlePageChange, onUserSelect, openEditModal, openProgramListModal }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { users, currentPage, totalPages, loading } = useSelector((state) => state.admin_clients);
  const [openDropdown, setOpenDropdown] = useState(null);
  const { userType } = useSelector((state) => state.protect);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  
  const toggleDropdown = (id, event) => {
    if (openDropdown === id) {
      setOpenDropdown(null);
    } else {
      const rect = event.target.getBoundingClientRect();
      setDropdownPosition({ top: rect.bottom, left: rect.left-100 });
      setOpenDropdown(id);
    }
  };

  useEffect(() => {
    if (userType === 'client') {
      navigate('/~alexgambleadmin/meal-plan');
    }
  }, [userType]); 

  const handleDelete = (user, id) => {
    confirmAlert({
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this client?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => dispatch(deleteClient({ user, id, currentPage }))
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  const handleClickOutside = (event) => {
    const isDropdownToggle = event.target.closest('.dropdown-toggle');
    const isDropdownMenu = event.target.closest('.dropdown-menu');
    if (!isDropdownToggle && !isDropdownMenu) {
      setOpenDropdown(null);
    }
  };

  const coaches_min = useSelector((state) => state.app_options?.coaches_min);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const handleScroll = () => {
    setOpenDropdown(null);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);


  const handleCoachChange = (userId, coachId) => {

    if (coachId == '') {
      var confirmed = window.confirm(
      'Are you sure you want to unassign coach from this user?'
    );
    } else {
      var confirmed = window.confirm(
      'If you are assigning a different coach to this user, this user will not be visible in your list. Are you sure you want to assign this coach to this user?'
    );
    }
    
    if (confirmed) {
      dispatch(assignCoach({ userId, coachId }));
    }
  };

  const handleLoginAsUser = async (user_id) => {
    localStorage.setItem('directlogin', '1');
    await dispatch(loginAsUser(user_id));
};

  return (
    <> 
    <div className="table-responsive">
      <table className="table table-striped table-users table-alex printarea">
        <thead>
          <tr>
            <th>Name</th>

             {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
            <th>Assigned Coach</th>
            )}
            <th>Type</th>
            <th>Last Active</th>
            <th className="noprint">Manage</th>
          </tr>
        </thead>
        <tbody>
          {users && users.length > 0 ? (
            users.map((user) => (
              <tr key={user.id}>
                <td>
                  <div className="text-start">
                    {user.first_name} {user.last_name}
                    <div><b>Email</b>: {user.email}</div>
                  </div>
                </td>
 

                {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
                <td>
                  <select
                    className="form-control assign-select"
                    value={user.assigned_coach_id || ''}
                    onChange={(e) => handleCoachChange(user.id, e.target.value)}
                  >
                    {coaches_min && coaches_min.map((coach) => (
                      <option key={coach.id} value={coach.id}>
                        {coach.first_name} {coach.last_name}
                      </option>
                    ))}
                  </select>
                </td>
                )}
 
                <td>{user.user_type == 1? '1:1' : 'Academy'}</td>
                <td>{user.last_signin}</td>
                <td className="noprint">
                  <div className="text-center position-relative">
                   
                    <button
                      type="button"
                      className="bg-transparent border-0 p-0 dropdown-toggle btn-vert-dots"
                      aria-expanded="false"
                      onClick={(e) => toggleDropdown(user.id, e)} // Pass the event
                    >
                      <img src={optionsIcon} alt="Options" />
                    </button>

                    {openDropdown === user.id && (
                      <ul className="dropdown-menu dropdown-menu-end" 
                      style={{  display: 'block',
                            position: 'fixed',
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            zIndex: 1050, }}
                      >                        
                        <li>
                          <a
                          className="dropdown-item"
                          onClick={() => openEditModal(user)}
                        >
                          <img src={editIcon} alt="Edit" /> Edit
                        </a>
                        </li>

                        {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
                          <li>
                            <a className="dropdown-item" onClick={() => handleDelete(user, user.id)}>
                              <img src={deleteIcon} alt="Delete" /> Delete
                            </a>
                          </li>
                        )}

                        <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            onUserSelect(user.id);
                            toggleDropdown(user.id);
                          }}
                        >
                          <img src={iconEye} alt="View" /> View
                        </a>
                        </li>

                        <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            handleLoginAsUser(user.id);
                          }}
                        >
                          <img src={iconLoginAsUser} alt="View" />Login as User
                        </a>
                        </li>

                         <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            openProgramListModal(user);
                          }}
                        >
                          <img src={iconAssignProgram} style={{height:'25px'}}alt="View" />Assign Program
                        </a>
                        </li>

                        
                      </ul>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">{loading?'Loading Users List...':'No Users found'}</td>
            </tr>
          )}
        </tbody>
      </table>    
      </div> 
      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
    </>
  );
};

export default ClientsTable;